export default __webpack_public_path__ + "static/media/Step4.1fc58d37.png";